import React, { Suspense, type ComponentType } from "react";
import { PageContentFallback } from "~/components/Layout/Fallbacks";

export function lazyPage(
  factory: () => Promise<{ default: ComponentType<any> }>,
  Fallback: ComponentType = PageContentFallback,
) {
  const Lazy = React.lazy(factory);
  return function LazyPageRoute() {
    return (
      <Suspense fallback={<Fallback />}>
        <Lazy />
      </Suspense>
    );
  };
}

export function lazyNamedPage(
  exportName: string,
  factory: () => Promise<Record<string, unknown>>,
  Fallback: ComponentType = PageContentFallback,
) {
  return lazyPage(
    () =>
      factory().then((module) => ({
        default: module[exportName] as ComponentType<any>,
      })),
    Fallback,
  );
}
